import {Model} from "@tailflow/laravel-orion/lib/model";

export class RegionalPractice extends Model<{
    title: string,
    index: number,
    created_at: string,
    updated_at: string,
}> {

    $resource(): string {
        return "module/regional-practices";
    }
}
